export abstract class DeleteDiaryEntryCmd {
  abstract exec(
    props: DeleteDiaryEntryCmd.Props,
  ): Promise<DeleteDiaryEntryCmd.Response>;
}

export namespace DeleteDiaryEntryCmd {
  export type Props = {id: string};
  export type Response = void;
}
